// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { type FC } from 'react';
import { environment, isBuildDevelopment } from '@shared/environment';

export const BuildInfo: FC = () => (
  <div
    className="fixed bottom-2 right-2 z-50 aria-hidden:hidden"
    aria-hidden={!isBuildDevelopment}
  >
    <span className="select-none rounded bg-gray-800 px-2 py-0.5 font-inter text-[10px] tabular-nums leading-4 text-white shadow">
      v{environment.APP.VERSION}.{environment.APP.BUILD_ID}
    </span>
  </div>
);
